import { Component, Input } from '@angular/core'

import { Overview } from '../../overview.model'

@Component({
  selector: 'fund-management',
  templateUrl: './fund-management.component.html',
  styleUrls: ['./fund-management.component.scss'],
})
export class FundManagementComponent {
  @Input()
  overviewModel: Overview

  public get fundManagementText(): string {
    const isFundW502 = this.overviewModel.fundId.toUpperCase() === 'W502'
    const defaultText =
      'The portfolio does not employ an investment advisor, but it benefits from the investment advisory services of the underlying Vanguard mutual fund(s) in which it invests.'
    const W502Text = 'The portfolio does not employ an investment advisor.'

    return isFundW502 ? W502Text : defaultText
  }
}
